/**
 * Fixed set of Property Guide categories, mirrored from
 * server/blog-categories.js (kept in sync by hand - see that file's
 * comment for why this isn't a dynamic admin-managed taxonomy).
 */
export const BLOG_CATEGORIES = [
  {
    slug: 'buying',
    label: 'Buying Property',
    description: 'Advice for buying property in Nigeria: due diligence, financing, negotiation and closing.',
  },
  {
    slug: 'renting',
    label: 'Renting',
    description: 'Guidance for tenants and landlords on renting property in Nigeria, from agreements to move-in checks.',
  },
  {
    slug: 'short-lets',
    label: 'Short Lets',
    description: 'Tips for booking, hosting and pricing short-let stays across Nigerian cities.',
  },
  {
    slug: 'investment',
    label: 'Property Investment',
    description: 'Analysis and advice on investing in Nigerian real estate, from rental yields to off-plan risk.',
  },
  {
    slug: 'market',
    label: 'Property Market',
    description: 'Market trends, price movements and demand signals across Nigeria’s property market.',
  },
  {
    slug: 'locations',
    label: 'Locations & Neighbourhoods',
    description: 'Neighbourhood guides covering what it’s actually like to live in areas across Nigeria.',
  },
  {
    slug: 'development',
    label: 'Property Development',
    description: 'Insights for developers and buyers on new-build projects and property development in Nigeria.',
  },
  {
    slug: 'legal',
    label: 'Legal & Property Advice',
    description: 'Land documentation, title verification and other legal essentials for Nigerian property transactions.',
  },
  {
    slug: 'agent-insights',
    label: 'Agent & Consultant Insights',
    description: 'Perspectives from property consultants, agents and other professionals working in Nigerian real estate.',
  },
  {
    slug: 'policy',
    label: 'Policy',
    description: 'Government policy, regulation and housing initiatives affecting Nigeria’s property market.',
  },
];

export const blogCategoryLabel = (slug) =>
  BLOG_CATEGORIES.find((c) => c.slug === slug)?.label || slug;

export const blogCategoryDescription = (slug) =>
  BLOG_CATEGORIES.find((c) => c.slug === slug)?.description || '';
